import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={378}
    height={252}
    fill="none"
    {...props}
  >
    <path
      fill="#EEEEF3"
      fillRule="evenodd"
      d="M66.088 126.351a9.424 9.424 0 0 1 9.424-9.424c48.738 0 84.699 9.737 118.694 19.192l2.031.565c33.191 9.236 64.466 17.938 105.448 17.938 5.204 0 9.423 4.219 9.423 9.424s-4.219 9.424-9.423 9.424c-43.581 0-76.992-9.3-109.973-18.481l-2.556-.711c-33.775-9.394-67.638-18.504-113.644-18.504-5.205.001-9.424-4.219-9.424-9.423"
      clipRule="evenodd"
    />
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M311.115 63.525a9.424 9.424 0 0 0-9.424-9.424c-28.079 0-48.756 6.35-68.319 19.22-18.794 12.365-36.385 30.69-58.435 53.658l-.669.698c-43.558 45.372-78.839 52.075-98.75 52.075a9.424 9.424 0 0 0-9.423 9.424 9.424 9.424 0 0 0 9.424 9.424c25.324 0 65.433-9.004 112.345-57.87 22.871-23.824 39.04-40.593 55.867-51.663 16.248-10.69 33.266-16.119 57.96-16.119a9.424 9.424 0 0 0 9.424-9.423"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLine;
